export const sectionA = "A部分：基本信息";
export const sectionB = "B部分：公司";
export const userBinding = "用户绑定";
export const taxpayerInfo = "纳税人信息维护";
export const contractDetails = "合同详情";

export const taxpayerSectionA = "A部分：纳税人信息";
export const taxpayerSectionB = "B部分：合同信息";
export const taxpayerSectionC = "C部分：用户信息";
export const businesSystemPermissions="业务系统权限";
export const selectBusinessSystem="选择业务系统";


export const account = {label:"账号",name:"account"};
export const userName = {label:"用户名",name:"userName"};
export const contactNumber = {label:"联系电话",name:"contactNumber"};
export const numberOfContracts = {label:"合同数量",name:"numberOfContracts"};
export const contactName = {label:"联系人姓名",name:"contactName"};
export const email = {label:"邮箱",name:"email"};
export const userType = {label:"用户类型",name:"userType"};
export const roleName = {label:"角色名称",name:"rolename"};
export const businessSystems = {label:"业务系统权限",name:"businessSystems"};
export const roleManagement = {label:"角色管理",name:"roleManagement"};
export const plsSelectPerm = "请选择权限";
export const plsSetOtherRoles = "请设置管理员以外的其他角色。";


export const contractNumber = {label:"合同编号",name:"contractNumber"};
export const contractStartDate = {label:"合同开始日期",name:"contractStartDate"};
export const contractEndDate = {label:"合同结束日期",name:"contractEndDate"};
export const userLimit = {label:"用户数量限制",name:"userLimit"};
export const remainingUserLimit = {label:"剩余可添加用户数量",name:"remainingUserLimit"};
export const transactionLimit = {label:"交易数量限制",name:"transactionLimit"};
export const remainingTransactionLimit = {label:"剩余可添加交易数量",name:"remainingTransactionLimit"};
export const invoiceLimit = {label:"开票数量限制",name:"invoiceLimit"};
export const remainingInvoiceLimit = {label:"剩余可开票数量",name:"remainingInvoiceLimit"};
export const contractStatus = {label:"合同状态",name:"contractStatus"};
export const cancelReason = {label:"取消原因",name:"cancelReason"};

export const allBusinessStatus={label:"控制全部业务系统?",name:"allBusinessStatus"};

export const largeFileDownload = {label:"启用大文件下载",name:"largeFileDownload"};
export const businessSystemImportTemplateTip="业务系统只能使用此模板批量导入。";
export const taxpayerInfoBtnTip="只有管理员用户可以执行信息维护。";
export const bindingBtnTip="只有管理员可以执行用户绑定。";
